<curr-modal-popup>
  <div class="wrapper">
    <span class="title">{{ hint ? 'Hint' : 'Explanation' }}</span>
    <p *ngIf="hint" class="again">View the hint and try to answer the question again</p>
    <p [currMath]="hint || explanation"></p>
    <curr-button *ngIf="hint" class="button" (btnClick)="closeModal()">Try again</curr-button>
    <curr-button *ngIf="!hint" class="button" (btnClick)="closeModal()">Got it</curr-button>
  </div>
</curr-modal-popup>
